export const removeItemFromPagination = (pagination: any, objectId: number) => {
  pagination.total -= 1
  Object.keys(pagination.pages).forEach((pageNumber) => {
    pagination.pages[pageNumber] = pagination.pages[pageNumber].filter((pageId) => pageId !== objectId)
    if (pagination.pages[pageNumber].length === 0 && pageNumber !== '1') {
      pagination.currentPage = parseInt(pageNumber) - 1
    }
  })
}
